import Subheader from '../components/Subheader.jsx';

import '../styles.css';

// import gallery_img_1 from '../assets/gallery_imgs/gallery_img_1.jpeg';
// import gallery_img_2 from '../assets/gallery_imgs/gallery_img_2.jpeg';
// import gallery_img_3 from '../assets/gallery_imgs/gallery_img_3.jpeg';
// import gallery_img_4 from '../assets/gallery_imgs/gallery_img_4.jpeg';
// import gallery_img_5 from '../assets/gallery_imgs/gallery_img_5.jpeg';
// import gallery_img_6 from '../assets/gallery_imgs/gallery_img_6.jpeg';

function AboutUsPage() {
	const imgs = [1, 2, 3, 4, 5, 6];

	return (
		<div className="aboutus">
			<Subheader text="About Us" />
			<div className="aboutus-text-section">
				<h2>
					A group of highschool students driven to
					address pressing issues in our world
				</h2>

				<p>
					APL WIN is an initiative taken by a group of
					high school students from APL Global School,
					Thoraipakkam, Tamil Nadu, India. We have a
					passion for bringing change to the world. We,
					as the future generation, are slowly realizing
					the flaws and problems of our society and wish
					to bring equality to the world at large
				</p>
			</div>

			<div className="aboutus-imagestrip">
				{imgs.map((element) => (
					<img
						className="aboutus-imagestrip-img"
						alt="img"
						src={require(`../assets/gallery_imgs/gallery_img_${element}.jpeg`)}
					/>
				))}
			</div>

			<div className="aboutus-text-section">
				<h2>Our Goal</h2>
				<p>
					Our goal is to mobilize transgenerational
					communities of global citizens to build a
					tolerant and sustainable world for our future
				</p>
			</div>
		</div>
	);
}

export default AboutUsPage;
